import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import FeatureSection from './components/FeatureSection';
import ComparisonSection from './components/ComparisonSection';
import HowItWorksSection from './components/HowItWorksSection';
import FeaturedArticlesSection from './components/FeaturedArticlesSection';
import CTASection from './components/CTASection';
import TrustSection from './components/TrustSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://superbuyspread.rest';
const faviconUrl = 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/67defc9f4dfae2c04004e8ea78b88107.png';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  description: 'The ultimate Superbuy Spreadsheet resource hub providing research guides, spreadsheet organization methods, comparison tools, and shopping information.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
};

const organizationSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Superbuy Spreadsheet',
  url: siteUrl,
  logo: faviconUrl,
  description: 'An independent educational resource platform providing research guides, spreadsheet organization methods, comparison tools and shopping information.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen">
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <AboutSection />
        <FeatureSection />
        <ComparisonSection />
        <HowItWorksSection />
        <FeaturedArticlesSection />
        <CTASection />
        <TrustSection />
      </main>
      <Footer />
    </div>
  );
}